import React from "react";

import { dateFormatter } from "../../../utils/DataGrid/dateFormatter";

import DataGridTablePage from "../../../Components/DataGridTablePage/DataGridTablePage";
import { useLocation } from "react-router-dom";
import Test from "../../Test";

const fieldHeaderPairs = [
  { field: "STORE_CODE", headerName: "Branch" },
  { field: "STOCK_CODE", headerName: "Style" },
  { field: "MIN_LEVEL", headerName: "Minimum" },
  { field: "MAX_LEVEL", headerName: "Maximum" },
  // { field: "CUSTOMER_ID", headerName: "Customer Name" },
  {
    field: "updatedDate",
    headerName: "Updated Date",
    valueFormatter: (params) => dateFormatter(params),
  },
];

const filterColumn = [
  {
    field: "STORE_CODE",
    label: "BRANCH",
    component: "AutocompleteField",
    url: "/replenishment/msl-levels",
    overrideDataField: "branchList",
  },
  {
    field: "STOCK_CODE",
    label: "STYLE",
    component: "TextField",
  },
  {
    field: "MIN_LEVEL",
    label: "MINIMUM",
    component: "TextField",
  },
  {
    field: "MAX_LEVEL",
    label: "MAXIMUM",
    component: "TextField",
  },
  {
    field: "startDate",
    label: "Start Date",
    component: "TextField",
    type: "date",
  },
  {
    field: "endDate",
    label: "End Date",
    component: "TextField",
    type: "date",
  },
  // {
  //   field: "CUSTOMER_ID",
  //   label: "CUSTOMER NAME",
  //   component: "TextField",
  // },

  // {
  //   field: "soldToa",
  //   // label: "Sold To",
  //   component: "AutocompleteField",
  //   url: "/current/company-account/all",
  // },
];

const ReplenishmentMslLevel = () => {
  const location = useLocation();
  return (
    <DataGridTablePage
      headerTitle="List MSL Level"
      hideMenu={5}
      exportFeature={true}
      navigateState={location.state}
      columns={fieldHeaderPairs}
      filterColumn={filterColumn}
      // children={<Test />}
      pageUrl="/replenishment/msl-levels"
      columnsVisibility={
        {
          // HIST_ID: false,
        }
      }
    />
  );
};

export default ReplenishmentMslLevel;
